import React from "react";
import { Box, Typography, Button } from "@mui/material";
import Div from "@jumbo/shared/Div";
import { getAssetPath } from "app/utils/appHelpers";
import { ASSET_CODINGPAL } from "app/utils/constants/paths";

const statusImageMap = {
  400: "400.png",
  401: "401.png",
  403: "403.png",
  404: "404.png",
};

const ErrorView = ({ error, onBack, backButtonLabel }) => {
  const imageFile = statusImageMap[error?.status] || statusImageMap[404];
  const imagePath = getAssetPath(`${ASSET_CODINGPAL}/${imageFile}`, "380x206");

  const errorMessage =
    error?.title || error?.message || error || "Oops! An error occurred";

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
        boxSizing: "border-box",
        gap: 0.5,
        px: 2,
        overflowY: "auto",
        "&::before": {
          content: '""',
          display: "block",
          height: "env(safe-area-inset-top)",
        },
        "&::after": {
          content: '""',
          display: "block",
          height: "env(safe-area-inset-bottom)",
        },
      }}
    >
      <Div sx={{ display: "inline-flex" }}>
        <img
          src={imagePath}
          alt={`Error ${error?.status || "Unknown"}`}
          width={380}
          style={{ maxWidth: "100%", height: "auto" }}
        />
      </Div>
      <Typography
        align="center"
        component="h2"
        variant="h1"
        color="text.secondary"
      >
        {errorMessage}
      </Typography>
      {onBack && backButtonLabel && (
        <Button
          variant="contained"
          onClick={onBack}
          sx={{ textTransform: "none", mb: 2 }}
        >
          {backButtonLabel}
        </Button>
      )}
    </Box>
  );
};

export default ErrorView;
